// w8.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W8 = () => {
  return <WW config={pageConfigs.w8} />;
};

export default W8;
